// extracted by mini-css-extract-plugin
var _1 = "#68914d";
var _2 = "#9cc681";
var _3 = "#8ab46f";
var _4 = "8px";
var _5 = "6px";
var _6 = "8px";
var _7 = "0 1px 1px 0 rgba(0,0,0,.02) inset";
var _8 = "0 8px 8px -4px rgba(0,0,0,.03),0 16px 24px -4px rgba(0,0,0,.08)";
var _9 = "10px";
var _a = "#e8e8e8";
var _b = "16px 24px";
var _c = "#38aa73";
var _d = "#956c22";
var _e = "#2988bd";
var _f = "#eee";
var _10 = "#c4842d";
var _11 = "#b8567c";
var _12 = "#8b6e4e";
var _13 = "#5889c2";
var _14 = "#4e8a8a";
var _15 = "#6a8a3e";
var _16 = "#7b5ea7";
var _17 = "#4a6fa5";
var _18 = "#3a8a6e";
var _19 = "#c25b4e";
var _1a = "#fafbfc";
var _1b = "#1e3050";
var _1c = "#293d62";
var _1d = "#fafbfc";
var _1e = "rgba(0,0,0,.12)";
var _1f = "#d9d9d9";
var _20 = "rgba(5,5,5,.1)";
var _21 = "#eaf2fc";
var _22 = "rgba(0,0,0,.65)";
var _23 = "#ebebeb";
var _24 = "#068467";
var _25 = "rgba(6,132,103,.1)";
var _26 = "#dc4949";
var _27 = "rgba(220,73,73,.1)";
var _28 = "#787c81";
var _29 = "#d6d9dc";
var _2a = "#f3f5f7";
var _2b = "#73c9b2";
var _2c = "linear-gradient(180deg, #73C9B2 0%, #B8E7DA 100%)";
var _2d = "#b8e7da";
var _2e = "#5357f8";
var _2f = "rgb(14.3921787709,19.9877094972,245.2078212291)";
var _30 = "rgb(249.6189944134,249.7441340782,254.7810055866)";
var _31 = "#f7f8f9";
var _32 = "#edeeef";
var _33 = "#7b8996";
var _34 = "#ededed";
var _35 = "#f4f5f7";
var _36 = "#fbfbfc";
var _37 = "rgba(0,0,0,.75)";
var _38 = "rgba(171.2567039106,172.4612273574,220.9432960894,.95)";
var _39 = "rgba(0,0,0,.3)";
var _3a = "rgba(0,0,0,.5)";
var _3b = "rgba(0,0,0,.4)";
var _3c = "rgba(0,0,0,.95)";
var _3d = "rgba(0,0,0,.65)";
var _3e = "rgba(0,0,0,.85)";
var _3f = "20px";
var _40 = "#f41e28";
var _41 = "1063px";
var _42 = "rgba(227,89,86,.2)";
var _43 = "#e35956";
var _44 = "16px 24px";
var _45 = "28px";
var _46 = "32px";
var _47 = "18px";
var _48 = "14px";
var _49 = "14px";
var _4a = "15px";
var _4b = "12.6px";
var _4c = "11px";
var _4d = "20px";
var _4e = "28px";
var _4f = "700";
var _50 = "200";
var _51 = "300";
var _52 = "500";
var _53 = "400";
var _54 = "600";
var _55 = "hsla(0,0%,100%,.2)";
var _56 = "#ccc";
var _57 = "49px";
var _58 = "5px";
var _59 = "#5357f8";
var _5a = "rgba(0,0,0,.4)";
var _5b = "main-heading___CwFHR";
var _5c = "#fafafa";
var _5d = "hsla(0,0%,100%,.9)";
var _5e = "15px";
var _5f = "20px";
var _60 = "24px";
var _61 = "secondary-heading___JbEka";
var _62 = "hsla(0,0%,100%,.6)";
var _63 = "#7e7eff";
var _64 = "hsla(0,0%,100%,.7)";
var _65 = "hsla(0,0%,100%,.3)";
var _66 = "hsla(0,0%,100%,.575)";
var _67 = "60px";
var _68 = "208px";
var _69 = "rgba(82,196,26,.2)";
var _6a = "#52c41a";
var _6b = "12px";
var _6c = "20px";
var _6d = "rgba(250,173,20,.2)";
var _6e = "#faad14";
var _6f = "#fff";
var _70 = "hsla(0,0%,100%,.2)";
export { _1 as "actionButtonColorDark", _2 as "actionButtonColorLight", _3 as "actionButtonColorMedium", _4 as "borderRadiusCard", _5 as "borderRadiusMain", _6 as "borderRadiusSurface", _7 as "boxShadowInnerXs", _8 as "boxShadowXl", _9 as "btnRightMargin", _a as "cardBorderColor", _b as "cardPadding", _c as "changeSetCompletedColor", _d as "changeSetManuallyChangesProposed", _e as "changeSetScheduledChangesProposed", _f as "chipBackground", _10 as "colorAccentAmber", _11 as "colorAccentBerry", _12 as "colorAccentBrown", _13 as "colorAccentCornflower", _14 as "colorAccentCyan", _15 as "colorAccentOlive", _16 as "colorAccentPurple", _17 as "colorAccentSteelBlue", _18 as "colorAccentTeal", _19 as "colorAccentTerracotta", _1a as "colorBackgroundMain", _1b as "colorBackgroundSidebar", _1c as "colorBackgroundSidebarHover", _1d as "colorBackgroundTabs", _1e as "colorBorderContainer", _1f as "colorBorderMain", _20 as "colorBorderSecondary", _21 as "colorDeltaCyanBlueBg", _22 as "colorDeltaGray", _23 as "colorDeltaGrayBg", _24 as "colorDeltaGreen", _25 as "colorDeltaGreenBg", _26 as "colorDeltaRed", _27 as "colorDeltaRedBg", _28 as "colorDetailsFieldText", _29 as "colorDetailsIcon", _2a as "colorDetailsTagBg", _2b as "colorMint", _2c as "colorMintGradient", _2d as "colorMintLight", _2e as "colorPrimary", _2f as "colorPrimaryHover", _30 as "colorPrimaryLightened", _31 as "colorTableHeadBg", _32 as "colorTableHeadBgHover", _33 as "colorTableHeadSubtitle", _34 as "colorTableRowBorder", _35 as "colorTableTextBg", _36 as "colorTableTotalRowBg", _37 as "colorTextBase", _38 as "colorTextDisabled", _39 as "colorTextExtraLight", _3a as "colorTextLight", _3b as "colorTextLighter", _3c as "colorTextMainHeading", _3d as "colorTextMuted", _3e as "colorTextPrimary", _3f as "contentHorizPadding", _40 as "dangerColor", _41 as "dashboardPdfContentWidth", _42 as "errorBackcolor", _43 as "errorColor", _44 as "filterPanelPadding", _45 as "filtersDefaultHeight", _46 as "filtersTallHeight", _47 as "fontSizeLarge", _48 as "fontSizeMain", _49 as "fontSizeMedium", _4a as "fontSizePlus", _4b as "fontSizeSmaller", _4c as "fontSizeSmallest", _4d as "fontSizeXLarge", _4e as "fontSizeXxLarge", _4f as "fontWeightBold", _50 as "fontWeightExtraLight", _51 as "fontWeightLight", _52 as "fontWeightMediumBold", _53 as "fontWeightNormal", _54 as "fontWeightSemiBold", _55 as "ghostWhite", _56 as "grayBackgroundColor", _57 as "headerHeight", _58 as "iconHorizontalMargin", _59 as "linkColor", _5a as "linkColorMuted", _5b as "main-heading", _5c as "popoverHeaderColor", _5d as "popoverMaskColor", _5e as "rowPadding", _5f as "ruleInnerGutters", _60 as "ruleSideGutters", _61 as "secondary-heading", _62 as "sideMenuIconColor", _63 as "sideMenuIconSelectedColor", _64 as "sideMenuItemColor", _65 as "sideMenuScrollbarThumbColor", _66 as "sideMenuSubmenuItemColor", _67 as "sidebarCollapsedWidth", _68 as "sidebarWidth", _69 as "successBackcolor", _6a as "successColor", _6b as "tableHeaderVerticalPadding", _6c as "tableHorizPadding", _6d as "warningBackcolor", _6e as "warningColor", _6f as "whiteColor", _70 as "whiteDividerColor" }
